<template>
  <v-row>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card>
        <v-card-title>
          Live EUREC<sup>4</sup>A platform positions
        </v-card-title>
        <v-card-text
          >This map is using the EUREC4A field campaigns MQTT broker
          <a
            href="https://www.meteo.physik.uni-muenchen.de/~tobias.koelling/mqtt_dashboard/about"
            target="_blank"
            >(more information)</a
          ></v-card-text
        >
        <v-container fluid>
          <v-row justify="center">
            <div
              id="mapid"
              style="margin:-7px 0px 0px 0px;width:100%; height:500px; z-index:0;"
            ></div>
          </v-row>
          <v-card style="margin-top:10px">
            <v-card-title>
              Platform list
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="platformsM"
              :items-per-page="10"
              :search="search"
              class="elevation-1"
              dense
            ></v-data-table>
          </v-card>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "mqtt",
  data() {
    return {
      mymap: null,
      buff2: "coucou",
      buff: "coucou",
      msg: "",
      platformsM: [],
      platformsL: [],
      platforms: [],
      markers: null,
      markersArr: [],
      search: "",
      headers: [
        {
          text: "Name",
          value: "long_name"
        },
        { text: "Type", value: "platform_types" },
        { text: "Planet ID", value: "planet_id" },
        { text: "Latitude", value: "lat", align: "right" },
        { text: "Longitude", value: "lon", align: "right" },
        { text: "Last communication", value: "time2" }
        // { text: 'Last2', value: 'time2' }
        // { text: 'Sensors', value: 'sensors' }
      ]
    };
  },
  mounted() {
    this.$mqtt.subscribe("platform/+/meta");
    this.$mqtt.subscribe("platform/+/location");
    this.mymap = L.map("mapid", { zoomSnap: 0.5, zoomDelta: 0.5 }).setView(
      [12, -55],
      6.5
    );
    L.circle([13.3, -57.717], 110000, {
      weight: 1,
      color: "blue",
      opacity: 1,
      fillColor: "blue",
      fillOpacity: 0.05
    }).addTo(this.mymap);
    this.mymap.scrollWheelZoom.disable();
    L.control.scale().addTo(this.mymap);

    L.latlngGraticule({
      showLabel: true,
      color: "#777",
      zoomInterval: [
        { start: 2, end: 3.5, interval: 30 },
        { start: 4, end: 4.5, interval: 10 },
        { start: 5, end: 7.5, interval: 5 },
        { start: 8, end: 10, interval: 1 }
      ]
    }).addTo(this.mymap);

    L.tileLayer(
      "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
      {
        maxZoom: 18,
        noWrap: true,
        attribution: "",
        id: "mapbox.streets"
      }
    ).addTo(this.mymap);
  },
  beforeDestroy() {
    this.$mqtt.unsubscribe("platform/+/meta");
    this.$mqtt.unsubscribe("platform/+/location");
  },
  mqtt: {
    "platform/+/meta"(data, topic) {
      let tmp = JSON.parse(data);
      let t = topic.split("/");
      if (t.length > 0) tmp.id = t[1];
      else tmp.id = "";
      this.buff2 =
        this.buff2 + "META:" + tmp.id + ":  " + topic + "--" + data + "<br />";
      let ipl = -1;
      for (let i = 0; i < this.platformsM.length; i++)
        if (tmp.id == this.platformsM[i].id) ipl = i;
      if (ipl > 0) this.platformsM.splice(ipl, 1);

      this.platformsM.push(tmp);
    },
    "platform/+/location"(data, topic) {
      let tmp = JSON.parse(data);
      let t = topic.split("/");
      if (t.length > 0) tmp.id = t[1];
      else tmp.id = "";
      this.buff = "LOC:" + tmp.id + ":  " + topic + "--" + data + "<br />";
      let ipl = -1;
      for (let i = 0; i < this.platformsL.length; i++)
        if (tmp.id == this.platformsL[i].id) ipl = i;

      if (ipl > 0) this.platformsL.splice(ipl, 1);
      this.platformsL.push(tmp);

      for (let j = 0; j < this.platformsM.length; j++) {
        if (tmp.id == this.platformsM[j].id) {
          if (isNaN(tmp.lat)) this.platformsM[j].lat = "";
          else this.platformsM[j].lat = Number(tmp.lat).toFixed(6);

          if (isNaN(tmp.lon)) this.platformsM[j].lon = "";
          else this.platformsM[j].lon = Number(tmp.lon).toFixed(6);

          this.platformsM[j].time = this.formatDate(tmp.time);
          this.platformsM[j].time2 =
            this.formatDate(tmp.time) +
            "  (" +
            this.countUpFromTime(tmp.time) +
            ")";
        }
      }

      //hhack to force refresh datatable
      this.platformsM.push("loading");
      this.platformsM.pop();
    }
  },
  methods: {
    countUpFromTime: function(countFrom) {
      //countFrom = new Date(countFrom).getTime();
      var now = new Date(),
        countFrom2 = new Date(countFrom + "Z"),
        timeDifference = now - countFrom2;

      var secondsInADay = 60 * 60 * 1000 * 24,
        secondsInAHour = 60 * 60 * 1000;

      let days = Math.floor((timeDifference / secondsInADay) * 1);
      let hours = Math.floor(
        ((timeDifference % secondsInADay) / secondsInAHour) * 1
      );
      let mins = Math.floor(
        (((timeDifference % secondsInADay) % secondsInAHour) / (60 * 1000)) * 1
      );
      let secs = Math.floor(
        ((((timeDifference % secondsInADay) % secondsInAHour) % (60 * 1000)) /
          1000) *
          1
      );
      let res = days + " days, " + hours + " hours, " + mins + " mins";
      if (days == 0) {
        res = hours + " hours, " + mins + " mins";
        if (hours == 0) res = mins + " mins";
      }

      return res;
    },
    formatDate: function(d) {
      let res = "";
      if (d && d.length > 16) res = d.substr(0, 16);

      return res.replace("T", " ");
    },
    updateMap: function() {
      this.markersArr = [];
      if (this.markers != null) this.markers.clearLayers();

      for (let i = 0; i < this.platformsL.length; i++) {
        let pname = "";
        let popup = "";
        for (let j = 0; j < this.platformsM.length; j++) {
          let it = this.platformsM[j];
          if (this.platformsL[i].id == it.id) {
            pname = it.platform_types.join("-");
            popup =
              "<strong>" + it.id + ": " + it.long_name + "</strong><br />";
            popup +=
              "<li>Last communication: " + this.platformsL[i].time + "<br />";
            popup +=
              "<li>Last location: lat: " +
              this.platformsL[i].lat +
              "°, lon: " +
              this.platformsL[i].lon +
              "°<br />";
            for (var p in it) {
              if (typeof it[p] === "object") {
                popup += "<li>" + p + ": <br />";
                let to = it[p];
                for (var p2 in to) {
                  if (typeof to[p2] === "object") {
                    let tmppop = JSON.stringify(to[p2]);
                    tmppop = tmppop.replace(/[",{,},\[,\]]/gi, "");
                    popup += "&nbsp;&nbsp;&nbsp;&nbsp;- " + tmppop + "<br />";
                  } else
                    popup += "&nbsp;&nbsp;&nbsp;&nbsp;- " + to[p2] + "<br />";
                }
              } else {
                if (p != "long_name")
                  popup += "<li> " + p + ": " + it[p] + "<br />";
              }
            }
          }
        }
        let iurl = "imgs/icons/ship_int.png";
        if (pname.indexOf("buoy") > -1) iurl = "imgs/icons/mooring.png";
        if (pname.indexOf("station") > -1) iurl = "imgs/icons/station.png";
        if (pname.indexOf("plane") > -1) iurl = "imgs/icons/plane8.png";
        if (pname.indexOf("radar") > -1) iurl = "imgs/icons/radar.png";
        if (pname.indexOf("ship") > -1) iurl = "imgs/icons/ship.png";
        if (pname.indexOf("saildrone") > -1) iurl = "imgs/icons/saildrone.png";
        if (pname.indexOf("drifter") > -1) iurl = "imgs/icons/drifter.png";
        if (pname.indexOf("glider") > -1) iurl = "imgs/icons/slocum.png";
        if (pname.indexOf("satellite") > -1) iurl = "imgs/icons/satellite.png";

        var sIcon = L.icon({
          iconUrl: iurl,
          iconSize: [24, 24],
          iconAnchor: [12, 12],
          popupAnchor: [0, 0]
        });
        let mk = L.marker([this.platformsL[i].lat, this.platformsL[i].lon], {
          icon: sIcon
        });
        mk.bindPopup(popup);

        this.markersArr.push(mk);
      }
      this.markers = L.layerGroup(this.markersArr).addTo(this.mymap);
    }
  },
  watch: {
    platformsL: function(val) {
      if (val.length > 0) this.updateMap();
    },
    platformsM: function(val) {
      if (val.length > 0) this.updateMap();
    }
  }
};
</script>
